export enum AuthStorageKey {
  USER = '@gbs-auth/user',
  IS_ADMIN_VIEWING_AS_CLIENT = '@gbs-auth/is_admin_viewing_as_client',
}
